import { createContext } from 'react';
/** Dialogs reserve the intrinsic size of every tab panel. Sheets and pages keep lazy panels. */
export const DialogLayoutContext = createContext(false);
